import LANGUAGES from '../languages';

export default {
	SETTINGS_LANGUAGE_OPTIONS: LANGUAGES,
	TERMS_OF_SERVICES: {
		SERVICE_AGREEMENT: '',
	},
};
